import Page, { Meta } from "@layouts/page";
import { VetifyCertificateIllustrationUrl } from "@modules/verify-certificate/Info";
import VerifyCertificate from "@templates/VerifyCertificate";
import { NextPage } from "next";

const meta: Meta = {
  title: "فرادرس | استعلام گواهینامه",
  description:
    "در این صفحه با وارد کردن شماره گواهینامه، از اعتبار آن اطمینان حاصل کنید.",
  image: VetifyCertificateIllustrationUrl,
};
const CertificateVerifyPage: NextPage = () => {
  return (
    <Page meta={meta}>
      <VerifyCertificate />
    </Page>
  );
};

export default CertificateVerifyPage;
